var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { TextArea } from "grommet";
export var StyledTextArea = styled(TextArea)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  line-height: 22px;\n  font-style: italic;\n  color: black;\n  min-height: 256px;\n  max-width: 406px;\n",
    ]))
);
